var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "dialog",
      {
        ref: "dialog",
        staticClass: "dialog",
        attrs: { id: "designer__dialog" },
      },
      [
        _c(
          "div",
          { staticClass: "dialog__header" },
          [
            _vm._t("header"),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button button__close",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.emitCloseDialog()
                  },
                },
              },
              [
                _vm._v("\n        ×\n        "),
                _c("span", { staticClass: "is-sr-only" }, [_vm._v("Close")]),
              ]
            ),
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "dialog__wrapper" }, [
          _c("div", { staticClass: "dialog__content" }, [_vm._t("content")], 2),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }